import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useHistory } from 'react-router-dom';
import { socket } from "src/socket";
import { useJwt } from "react-jwt";

import ProtectedRoutes from "./protectedRoutes";
import routesCoach from "./routesCoach";
import routesClient from "./routesClient";
import publicRoutes from "./appRoutes/publicRoutes";

//Service
import { logout, updatePayment } from 'src/reducers/sessionSlice';
import { setAlert } from "src/reducers/alertSlice";
import { disconnect, connect } from "src/reducers/socketSlice";
import { getPaymentRedirect } from "src/Utils/subscriptionAccess";
import { getMe } from "src/Api/services/authService";
import { makePaymentRefresher, SUBSCRIPTION_REQUIRED_EVENT } from "src/Api/subscriptionRequired";
import { CLIENT_CLOSED_EVENT } from "src/Api/clientClosed";
import { CLOSED_CLIENT_MESSAGE } from "src/Utils/closedClients";

const Routes = () => {

    const location = useLocation();
    const dispatch = useDispatch();
    const history = useHistory();

    const session = useSelector((state) => state.session);

    //console.log("session", session);

    const socketState = useSelector((state) => state.socket);
    const userRoutes = session.userType === 'coach' ? routesCoach : routesClient;
    const { decodedToken, isExpired } = useJwt(session?.token ? session.token : '');

    useEffect(() => {
        socket.on('UPDATE_PAYMENT', (newPayment) => {
            dispatch(updatePayment({ payment: newPayment }));
        });

        return () => {
          socket.off('UPDATE_PAYMENT');
        };
    }, []);

    // Cuando la API responde 402 SUBSCRIPTION_REQUIRED, la sesión en Redux puede
    // tener un payment viejo: se refresca con /auth/me y el efecto de
    // getPaymentRedirect se encarga de llevar al coach a /payment.
    useEffect(() => {
        const refresh = makePaymentRefresher({
            fetchMe: getMe,
            onPayment: (payment) => dispatch(updatePayment({ payment })),
        });
        window.addEventListener(SUBSCRIPTION_REQUIRED_EVENT, refresh);
        return () => window.removeEventListener(SUBSCRIPTION_REQUIRED_EVENT, refresh);
    }, []);

    useEffect(() => {
        // En el siguiente tick, para que reemplace el error genérico que muestra la pantalla.
        const showMessage = () => setTimeout(() => dispatch(setAlert({ msg: CLOSED_CLIENT_MESSAGE, type: 'error' })));
        window.addEventListener(CLIENT_CLOSED_EVENT, showMessage);
        return () => window.removeEventListener(CLIENT_CLOSED_EVENT, showMessage);
    }, []);

    useEffect(() => {
        const redirect = getPaymentRedirect(session, location.pathname, new Date(), location.search);
        if (redirect) {
            history.push(redirect);
        }
    }, [session, location]);

    useEffect(() => {
        const verify = async () => {
            if (isExpired) {
                dispatch(
                    setAlert({
                        msg: "Su sesión ha expirado, por favor inicie sesión nuevamente",
                        type: "error",
                    })
                );
                dispatch(disconnect());
                dispatch(logout());
                history.push("/");
            }
        }
        if (session?.isLogged && session?.token && decodedToken)
            verify();
    }, [session, location]);

    useEffect(() => {
        socket.on('connect', () => {
            //console.log("CONNECT SOCKET");
            socket.emit('ADD_SOCKET', {
                user: session.user?.id,
                socket: socket.id,
                room: session.user?.group ? session.user?.group.id : session.user?.id
            });
            dispatch(connect({ socketId: socket.id }));
            dispatch(setAlert({ msg: 'Ahora estas conectado.', type: 'success' }));
        });
        socket.on('disconnect', () => {
            //console.log("DISCONNECT SOCKET");
            dispatch(disconnect());
            //dispatch(setAlert({ msg: 'Se perdio la conexión con el servidor, reconectando...', type: 'warning' }));

        });
        socket.on('connect_error', () => {
            //console.log("CONNECT ERROR SOCKET");
            dispatch(setAlert({ msg: 'Ocurrio un error al conectar con el servidor.', type: 'error' }));
        });
        return () => {
            socket.off('connect');
            socket.off('disconnect');
            socket.off('connect_error');
        };
    }, [session]);

    useEffect(() => {
        if (socketState?.isConnected && !socket.connected) {
            socket.connect();
        }
    }, [socketState]);

    return (
        <>
            {publicRoutes.map((route) => (
                <ProtectedRoutes
                    key={route.path}
                    path={route.path}
                    exact={route.exact}
                    isPrivate={route.isPrivate}
                    component={route.element}
                />
            ))}
            {userRoutes.map((route) => (
                <ProtectedRoutes
                    key={route.path}
                    path={route.path}
                    exact={route.exact}
                    isPrivate={route.isPrivate}
                    component={route.element}
                />
            ))}
        </>
    );
}


export default Routes;
